import { render, staticRenderFns } from "./RoutesDataTable.vue?vue&type=template&id=2d44fa08&scoped=true"
import script from "./RoutesDataTable.vue?vue&type=script&lang=js"
export * from "./RoutesDataTable.vue?vue&type=script&lang=js"
import style0 from "./RoutesDataTable.vue?vue&type=style&index=0&id=2d44fa08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44fa08",
  null
  
)

export default component.exports